export default [
    {
        id: 1,
        img: "image-emily.jpg",
        testimony: "We put trust in sunnyside and they deliver. Making sure our needs were met and and deadlines were always hit",
        name: "Emily R.",
        designation: "Marketing Director",
        alt: "Picture of Emily"
    },
    {
        id: 2,
        img: "image-thomas.jpg",
        testimony: "Sunnyside's enthusiasm coupled with their keen interest in our brand's success made it a satisfying and enjoyable experience.",
        name: "Thomas S.",
        designation: "Chief Operating Officer",
        alt: "Picture of Thomas"
    },
    {
        id: 3,
        img: "image-jennie.jpg",
        testimony: "Incredible end result! Our sales increased over 400%. when we worked with Sunnyside. Highly recommended!",
        name: "Jennie F.",
        designation: "Business Owner",
        alt: "Picture of Jannie"
    },
]